import { useContext } from 'react';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import FiltersBtn from '../../customize/components/FiltersBtn';
import { allSpecialFilterKey, isFoodsPage } from '../../customize/const';
import useDrag from '../../../../../pages/customize/UseDrag';
import { Icon, IconVariant } from '@hungryroot/icons';

import 'react-horizontal-scrolling-menu/dist/styles.css';
import clsx from 'clsx';
import styles from './TopFilterBar.module.css';

const allKey = allSpecialFilterKey.toString();

// filterOptions is a array of strings
export default function TopFilterBar(props) {
  const isMobile = $.browser.mobile;

  let { selectedFilter, selectFilter, isRecipe } = props;
  // because of the scroller selected filter has to be a string
  selectedFilter = selectedFilter.toString();

  const selectNewFilter = (id) => {
    if (id === selectedFilter) {
      return;
    }
    selectFilter(parseInt(id));
    let yPosition = 0;
    if (isFoodsPage) {
      yPosition = 390;
    } else {
      yPosition = isMobile ? 230 : 390;
    }
    window.scroll(0, yPosition);
  };

  const createMenu = () => {
    let {
      filterOptions,
      selectedFilter,
      filterCounts,
      filterDietaryCounts,
      selectFilter,
    } = props;
    // because of the scroller selected filter has to be a string
    selectedFilter = selectedFilter.toString();

    let allClassNames = clsx('filter-option', {
      selected: selectedFilter === allKey,
    });

    let menu = filterOptions.reduce(
      (acc, newOption) => {
        const newOptionId = newOption.id.toString();
        //Removing filter options depeding on the customer dietary preferences
        // if(!filterDietaryCounts[newOptionId]) return acc
        // make sure after loading the page the selected filter option is visibile
        let filterClasses = clsx(
          'filter-option',
          {
            selected: selectedFilter === newOptionId,
            disabled: !filterCounts[newOptionId],
          },
          []
        );
        acc.push(
          <div
            key={newOptionId}
            className={filterClasses}
            onClick={() => {
              selectNewFilter(newOption.id);
            }}
          >
            {newOption.name_plural}
          </div>
        );
        return acc;
      },
      [
        <div
          className={allClassNames}
          key={allKey}
          onClick={() => {
            selectNewFilter(allKey);
          }}
        >
          All
        </div>,
      ]
    );

    return menu;
  };

  const { dragMove } = useDrag();

  const handleDrag =
    ({ scrollContainer }) =>
    (ev) =>
      dragMove(ev, (posDiff) => {
        if (scrollContainer.current) {
          scrollContainer.current.scrollLeft += posDiff;
        }
      });

  const onWheel = (apiObj, ev) => {
    const isTouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

    if (isTouchpad) {
      ev.stopPropagation();
      return;
    }

    if (ev.deltaY < 0) {
      apiObj.scrollNext();
    } else if (ev.deltaY > 0) {
      apiObj.scrollPrev();
    }
  };

  const leftArrow = () => {
    const { isFirstItemVisible, scrollPrev } = useContext(VisibilityContext);

    return (
      <div
        className={`arrow ${isFirstItemVisible ? 'hide-arrow' : ''}`}
        onClick={() => scrollPrev()}
      >
        <Icon variant={IconVariant.CaretLeft} />
      </div>
    );
  };

  const rightArrow = () => {
    const { isLastItemVisible, scrollNext } = useContext(VisibilityContext);

    return (
      <div
        className={`arrow ${isLastItemVisible ? 'hide-arrow' : ''}`}
        onClick={() => scrollNext()}
      >
        <Icon variant={IconVariant.CaretRight} />
      </div>
    );
  };

  return (
    <div className="top-filter-bar">
      <div className={styles['hr-mobile']}>
        <FiltersBtn isRecipe={isRecipe} />
      </div>
      <div className="slider-container">
        <ScrollMenu
          LeftArrow={leftArrow}
          RightArrow={rightArrow}
          onMouseMove={handleDrag}
          onWheel={onWheel}
          wrapperClassName="wrapper"
          scrollContainerClassName="scroll-container"
          itemClassName="filter-option-parent"
          transitionBehavior={'smooth'}
        >
          {createMenu()}
        </ScrollMenu>
      </div>
    </div>
  );
}
